export class ChartMemberSelection {
    constructor(public chart: string, public dataMembers: string[], public dataLabels?: string[]) {
    }
}
